import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus } from "../../../common/types/order-details-history-entry-event";

const getHeadingText = (
  approvalStatus: OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus,
): string => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .changeApprovalStatus;

  switch (approvalStatus) {
    case OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus.ACCEPTED:
      return translations.acceptedHeadingLabel;
    case OrderDetailsHistoryEntryChangeApprovalStatusEventApprovalStatus.REJECTED:
      return translations.rejectedHeadingLabel;
  }
};

const orderDetailsHistoryEntryChangeApprovalStatusContentHelper = {
  getHeadingText,
};

export default orderDetailsHistoryEntryChangeApprovalStatusContentHelper;
